/** The locale's symbol for a currency code, e.g. "EUR" → "€"; falls back to the code. */
export const currencySymbol = (currency: string, language: string): string =>
  new Intl.NumberFormat(language, { style: "currency", currency: currency.toUpperCase() })
    .formatToParts(0)
    .find((part) => part.type === "currency")?.value ?? currency;

export const formatEur = (amount: number, language: string, currency: string) =>
  new Intl.NumberFormat(language, {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(amount);

export const formatBgn = (amountBgn: number, language: string) =>
  new Intl.NumberFormat(language, { style: "currency", currency: "BGN" }).format(amountBgn);

export const formatEurWithBgn = (amount: number, amountBgn: number | null, language: string, currency: string) => {
  const eur = formatEur(amount, language, currency);
  if (amountBgn == null) return eur;
  return `${eur} / ${formatBgn(amountBgn, language)}`;
};
